export const porkBroth = {
  id: "porkBroth",
  link: "/#/recipes/recipes/porkBroth",
  name: "Pork Broth",
  cuisine: "Kharbranthian",
  summary: "Pork bone broth with meltingly tender slices of pork belly",
  inspiration: "Tonkotsu broth",
  quantity: "9 servings",
  time: "14 hours",
  notes:
    "There were quite a few different ways I could have gone with this one. I simply needed a broth with some spice. I chose to look to tonkotsu, as I've always wanted to to try making it myself. The idea of a spiced broth, especially as a lighter dish that one might eat for lunch, reminded of miso soup. I decided to follow the pattern set there and not add too many fillings, but let the broth be the star. In many of the other recipes I've used the shortcut of using premade stocks. I wanted to have at least one recipe that made a flavorful broth from scratch with no shortcuts, and pork, being available on Roshar, seemed like the right choice.",
  quotes:
    "...a spicy-smelling broth for the king. Kharbranthians preferred soups for their lunches. (The Way of Kings ch 29)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/pork-broth-overview.jpg",
  ingredientSections: [
    {
      title: "Pork belly",
      ingredients: [
        {
          item: "salt",
          display: "2 tbsp salt"
        },
        {
          item: "sugar",
          display: "2 tbsp granulated sugar"
        },
        {
          item: "paprika",
          display: "1 tsp paprika"
        },
        {
          item: "pork",
          display: "2 lb pork belly"
        }
      ]
    },
    {
      title: "Broth",
      ingredients: [
        {
          item: "pork",
          display: "6 lbs pork neck bones"
        },
        {
          item: "onion",
          display: "1 onion"
        },
        {
          item: "garlicClove",
          display: "4 cloves garlic"
        },
        {
          item: "salt",
          display: "4 1/2 tsp salt, divided"
        },
        {
          item: "oysterSauce",
          display: "4 1/2 tsp oyster sauce, divided"
        },
        {
          item: "gochugaru",
          display: "9 tsp gochugaru, divided"
        }
      ]
    }
  ],
  steps: [
    "Combine 2 tbsp salt, the sugar, and paprika. If the pork belly still has the skin, remove it. Liberally coat the pork belly with the salt mixture on all sides. You may not use all of the mixture. Refrigerate uncovered for 10 hours.",
    "Meanwhile, place the pork neck bones in a very large stock pot and cover with plenty of cold water. Bring to a boil over high heat. Remove from heat, and pour off the water and gunk, reserving the bones. Rinse off the bones and the pot.",
    "Return the bones to the pot and cover with water well above the bones. Peel the onion and cut in half. Peel the garlic cloves. Add onion and garlic to the pot with the bones. Cover and bring to a roiling boil over medium high heat. Maintain the boil for 12 hours. Add water as needed to keep it from boiling dry, checking every hour or so. During the last hour, let it cook down a bit. You need enough liquid to cover the bones by a bit.",
    "Once the pork belly has refrigerated for 10 hours, remove it from the fridge. Briefly rinse off the salt mixture. Pat dry.",
    "Preheat the oven to 290 degrees Fahrenheit. Place the pork belly on a baking pan and cover with foil, keeping the foil high enough to not touch the meat. Bake until the pork is 190 degrees Fahrenheit inside as measured by a meat thermometer, about 2 hours. Remove from the oven and let rest 10 minutes. Slice into 1/4 inch thick slices.",
    "Once the pot has boiled for 12 hours, remove it from heat. Remove the bones and meat from the pot with a slotted spoon and discard. Reserve the broth. Strain the broth, discarding the solids.",
    "To serve, add 2 cups broth to a bowl. Mix in 1/2 tsp salt, 1/2 tsp oyster sauce, and 1 tsp gochugaru. Add 3 or 4 slices of pork belly."
  ]
}
